<template>
  <section class="timeline" 
  :class="{ mini: !mode }"
  >
    <div class="timeline-scroll">
      <!-- Поиск -->
      <div class="timeline-header">
        <div class="title-switcher" :class="{open: switcher}" v-if="!showSearch">
          <div class="title-dropdown">
            <h2 class="timeline-title active" @click="switcher = !switcher">Ивенты 
              <img src="@/assets/images/icons/arrow-down.svg" alt="">
            </h2>
            <router-link tag="h2" class="timeline-title" :to="{name: 'places'}">Места</router-link>
          </div>
        </div>
        <div class="search" v-if="showSearch">
          <div class="input-search">
              <input type="search" placeholder="Поиск" v-model="search" @input="searchByTitle" ref="search">
              <img src="@/assets/images/icons/icon_search-b.svg" width="22px">
          </div>
        </div>
        <div class="search-buttons">
          <div class="filters-button" :class="{active: getFilters.length > 0}" v-if="!showSearch" @click="changeState('filters')">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.33 16.593h-6.3M13.14 6.9h6.301"/>
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M8.726 6.846A2.355 2.355 0 006.363 4.5 2.355 2.355 0 004 6.846a2.355 2.355 0 002.363 2.347 2.355 2.355 0 002.363-2.347zM20 16.554a2.354 2.354 0 00-2.362-2.346 2.355 2.355 0 00-2.364 2.346 2.355 2.355 0 002.364 2.346A2.354 2.354 0 0020 16.554z" clip-rule="evenodd"/>
            </svg>
            <p v-if="getFilters.length > 0">{{ getFilters.length }}</p>
          </div>
          <div class="search-icon" v-if="!showSearch" @click="changeState('sports')">
            <img src="@/assets/images/icons/filters.svg" width="24px" />
          </div>
          <div class="search-icon" v-if="!showSearch" @click="changeOpenSearch()">
            <img src="@/assets/images/icons/icon_search-b.svg" width="22px" />
          </div>
          <div class="search-icon" v-if="showSearch" @click="changeOpenSearch()">
            <img src="@/assets/images/icons/icon_close.svg" width="22px" />
          </div>
        </div>
      </div>

      <!-- Навигация -->
      <div class="timeline-filters">
        <div class="timeline-string">
          <div class="timeline-buttons">
            <div class="button" :class="{ active: getTypeEvents == 'my_events' }" @click="setType('my_events')">
              Мои ивенты
            </div>
            <div
              class="button"
              :class="{ active: getTypeEvents == 'invites' }"
              @click="setType('invites')"
            >
              <p>Приглашения</p>
              <div class="nav-item__notif" v-if="getNotifications && getNotifications.invites">
                <p>{{ getNotifications.invites }}</p>
              </div>
            </div>
          </div>
        </div>

        <Sports :sports="getActiveSports" />
        <Info 
        @click.native="openAction()"
        :content="'Привет, ты зашел на этот сервис, тебе понравилась задумка и ты хочешь увидеть рабочий сервис для экстремальных видов спорта?'" 
        :description="'Создатель wildwood Алексей Чернов'" 
        :button="{text: 'Да'}"
      />
      </div>


      <!-- Список постов -->
      <div class="timeline-body" v-if="!timelineLoader">
        <div 
          class="timeline-group"
          v-for="(group, index) in getGroupedEvents"
          :key="index"
        >
          <h4 class="timeline-group__title">{{group.name}}</h4>
          <div class="timeline-group__body">
            <PostEvent 
              v-for="event of group.events" 
              :key="event.id" 
              :event="event" />
          </div>
        </div>
        <div class="timeline-info">
          <div class="button" v-if="showOld" @click="showOldEvents()">Показать прошедшие</div>
          <div class="timeline-nothing" v-if="!events || events.length === 0">
            <p>Ничего не найдено 💩</p>
          </div>
          <div class="button button_action" @click="openNewEvent()" v-if="!events || events.length === 0">
            <p>Создайте свой ивент</p>
          </div>
          <div class="timeline-nothing" v-if="events.error">
            <p>Что-то пошло не так...</p>
          </div>
        </div>
      </div>
      <PseudoTimeline v-else />
    </div>

    <!-- Кнопка скрытия списка -->
    <div class="timeline-toggle" v-if="events && !events.error">
      <div class="timeline-toggle__button" @click="mode = !mode">
        <p>{{ mode ? 'Скрыть' : 'Показать' }}</p>
      </div>
    </div>

    <!-- Кнопка открытия карты на мобиле -->
    <div class="timeline-openmap" @click="openMap()">
      <font-awesome-icon icon="map-marker-alt" />
      <p>Карта</p>
    </div>
  </section>
</template>

<script>
import PostEvent from './PostEvent'
import greatAgain from "@/data/main/greatAgain"

export default {
  props: {
    events: {
      type: Array,
      required: false,
    }
  },
  components: {
    // PostEvent: () => import('./PostEvent'),
    PostEvent,
    Sports: () => import('@/components/Filters/Sports'),
    PseudoTimeline: () => import('@/components/Pseudo/PseudoTimeline'),
    Info: () => import('@/components/UI/Info'),
  },
  data() {
    return {
      page: 1,
      sports: this.getActiveSports || null,
      mode: true,
      date: null,
      open_search: false,
      type_events: 'all',
      switcher: false
    };
  },
  computed: {
    showSearch() {
      return this.search && this.search.length > 0 || this.open_search
    },
    search: {
      get () {
        return this.$store.state.filters.search_events
      },
      set (value) {
        this.$store.commit('setSearchEvents', value)
      }
    },
    showOld() {
      let filter = this.getFilters.find(filter => filter.filter === 'stories');
      let has = this.getFilters.find(filter => filter.group === 'status');
      return !has && !filter
    },
    getGroupedEvents() {
      let result = [];
      if (this.events && this.events.length > 0) {
        let finished = this.events.filter(event => new Date(event.date_event) < new Date() && new Date(event.closed_plan) < new Date());
        let active = this.events.filter(event => new Date(event.date_event) < new Date() && new Date(event.closed_plan) > new Date());
        let future = this.events.filter(event => new Date(event.date_event) >= new Date());
        future.sort(function(a,b){
          return new Date(a.date_event) - new Date(b.date_event);
        });
        active && active.length > 0 
          ? result.push({
            name: 'Активные',
            events: active
          })
          : ''
        future && future.length > 0 
          ? result.push({
            name: 'Предстоящие',
            events: future
          })
          : ''
        finished && finished.length > 0 
          ? result.push({
            name: 'Прошедшие',
            events: finished
          })
          : ''
      }
      return result
    },
    getActiveSports() {
      return this.$store.getters.getActiveSports;
    },
    getDate() {
      return this.$store.getters.getDate;
    },
    getPage() {
      return this.$store.getters.getEventsPage;
    },
    getFilters() {
      return this.$store.getters.getFilters;
    },
    timelineLoader() {
      return this.$store.getters.timelineLoader;
    },
    getTypeEvents() {
      return this.$store.getters.getTypeEvents;
    },
    getNotifications() {
      return this.$store.getters.getUserNotifications;
    },
  },
  methods: {
    openAction() {
      this.$store.dispatch('setModal', greatAgain )
    },
    showOldEvents() {
      this.getFilters.push({filter: 'next', group: 'status'})
      this.getFilters.push({filter: 'now', group: 'status'})
      this.getFilters.push({filter: 'stories', group: 'status'})
    },
    openMap() {
      this.$store.dispatch('changeList', false);
      this.$store.dispatch('changeMode', 'map');
    },
    setType(type) {
      this.getTypeEvents == type ? this.$store.dispatch('setTypeEvents', 'all') : this.$store.dispatch('setTypeEvents', type);
    },
    hasActive(filter) {
      return this.getFilters.find((item) => item.filter == filter) ? true : false;
    },
    lazyLoad() {
      // let timeline = document.querySelector('.timeline-scroll');
      // timeline.addEventListener('scroll', async () => {
      //   if (timeline.scrollTop + timeline.clientHeight >= timeline.scrollHeight) {
      //     await this.$store.dispatch('nextPageEvents')
      //     this.$store.dispatch('getEvents', {page: this.getPage, filters: this.getFilters, sports: this.getActiveSports})
      //   }
      // })
    },
    changeOpenSearch() {
      this.open_search = !this.open_search
      !this.open_search || this.search.length > 0
        ? (this.search = '', this.searchByTitle()) 
        : this.focusOnSearch()
    },
    focusOnSearch() {
      setTimeout(() => {
        let search = this.$refs.search;
        search ? search.focus() : ''
      }, 100)
    },
    searchByTitle() {
      let search = this.search;
      if (search.length > 2 || search.length === 0) {
        let filters = this.getFilters;
        let finded = filters.find((filter) => filter.group === 'search');
        let filter = { filter: search, group: 'search' };
        finded ? filters.splice(filters.indexOf(finded), 1) : '';
        filters.push(filter);
        this.$store.dispatch('setFilters', filters);
      }
    },
    changeState(element) {
      this.$store.dispatch('changeState', { element: element, val: true });
    },
    openNewEvent() {
      this.$store.dispatch('setNewType', 'events');
      this.$store.dispatch('changeState', {element: 'workplace'});
    }
  },
};
</script>
